import { hapticFeedback } from "@telegram-apps/sdk-react";
import {
    Blockquote,
    Button,
    Placeholder,
    Title,
} from "@telegram-apps/telegram-ui";
import { FC, useEffect } from "react";

export const SystemError: FC<{ error: unknown }> = ({ error }) => {
    const errorName = error instanceof Error ? error.message : "";
    const errorBody =
        error instanceof Error
            ? error.stack
            : typeof error === "string"
              ? error
              : JSON.stringify(error);

    // TODO: error reporting

    useEffect(() => {
        hapticFeedback.notificationOccurred("error");
    }, []);

    return (
        <Placeholder
            style={{ padding: "32px 12px" }}
            header={
                <div className="flex items-center justify-center mb-5">
                    <span>Oops!</span>
                </div>
            }
            description={
                <>
                    <Title
                        level="3"
                        weight="3"
                        style={{
                            width: "calc(100vw - 24px)",
                            overflowX: "auto",
                            textAlign: "left",
                            color: "var(--tgui--text_color)",
                            marginBottom: 6,
                        }}
                    >
                        An unhandled error occurred: {errorName}
                    </Title>
                    <Blockquote
                        type="text"
                        topRightIcon={null}
                        style={{
                            width: "calc(100vw - 24px)",
                            overflowX: "auto",
                        }}
                    >
                        <pre>
                            <code className="text-direction1">{errorBody}</code>
                        </pre>
                    </Blockquote>
                </>
            }
            action={
                <Button
                    size="l"
                    stretched
                    onClick={() => {
                        hapticFeedback.impactOccurred("heavy");
                        window.location.reload();
                    }}
                >
                    Try Again
                </Button>
            }
        ></Placeholder>
    );
};
